import { map } from "rxjs/operators";
import {
  ChangeDetectorRef,
  Component,
  OnInit,
  ViewChild,
  Input,
  Output,
  EventEmitter,
  Renderer2,
  ElementRef,
} from "@angular/core";
import { Alert, AlertType } from "../../shared/alert.model";
import { ActivatedRoute, Router } from "@angular/router";
import { MessageService } from "../../shared/message.service";
import {
  McmdRole,
  SignOnPolicy,
  SignOnPolicyAssignment,
  User,
} from "../models/user.model";
import { UserService } from "../services/user.service";
import { shouldHidePolicy } from "../constants/policy-filter.constants";
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
  NgForm,
  FormArray,
  FormGroup,
  FormControl,
} from "@angular/forms";
import {
  NgbAccordion,
  NgbActiveModal,
  NgbModalRef,
} from "@ng-bootstrap/ng-bootstrap";
import { getAlertMessage } from "../../shared/api-loaders";
import { HttpParams } from "@angular/common/http";
import { EnrollMfaComponent } from "../../modal/enroll-mfa/enroll-mfa.component";
import { ModalService } from "../../shared/modal.service";
import { UserDetailService } from "../services/user-detail.service";
import { getRoleFromName } from "../shared";
import {
  PdOfficeData,
  Region,
  RolesDisciplines,
  UserDetailOptionsFacility,
} from "../models/user-detail-options";
import { UserTypeNames } from "../models/user-type-names";
import { CustomValidators } from "../validators/optional-email-validator";
import { RoleDisciplineValidator } from "../validators/role-discipline-validator";
import { Select2Option } from "../../shared/select2-option";
import { PhysicianNppaUserChildComponent } from "../physician-nppa-user-child/physician-nppa-user-child.component";
import { IUserRegion } from "../models/user-region.model";
import {
  DownlineTreeviewItem,
  OrderDownlineTreeviewEventParser,
  TreeviewComponent,
  TreeviewConfig,
  TreeviewEventParser,
  TreeviewItem,
} from "@laijuthomas/ngx-treeview";
import * as _ from "lodash-es";
import { TreeviewCustomConfig } from "../../treeview/treeview-custom-config";
import { ProductInfo } from "app/users/models/ProductInfo";
import { UserStatus } from "app/users/models/UserStatus";
import { ProductNames } from "../models/ProductNames";
import { arrayToObject } from "../../shared/app-util";
import { firstValueFrom, Observable, of, Subscription } from "rxjs";
import { MessageType } from "../../shared/messageType";
import { environment } from "../../../environments/environment";
import { SecurityService } from "../../shared/security.service";

import {
  AbstractControl,
  UntypedFormControl,
  NgModel,
  ValidatorFn,
  ValidationErrors,
  FormsModule,
} from "@angular/forms";
import { ToggleService } from "../../shared/toggle/toggle.service";
import { TransactionLogService } from "../services/transaction-log.service";
import { getPrefixesOptions } from "../models/Prefixes";
import { Select2OptionData } from "ng-select2";
import { TwoFactorResetConfirmtionDialogComponent } from "../../my-profile/two-factor-reset-confirmtion/two-factor-reset-confirmtion-dialog.component";
import { CustomerService } from "../../ect-feature/services/customer.service";
import { UserCustomerService } from "../services/user-customer.service";
import { UserActivateWithPasswordComponent } from "../user-activate-with-password/user-activate-with-password.component";
import { UserConversionToFederationConfirmationDialogComponent } from "../user-conversion-to-federation-confirmation/user-conversion-to-federation-confirmation-dialog.component";
import { IMultiSelectOption } from "ngx-bootstrap-multiselect";
import {
  getMultiSelectSettings,
  getMultiSelectTexts,
} from "../../shared/DropdownHelper";
import { EditUsernameDialogComponent } from "../edit-username-dialog/edit-username-dialog.component";
import { CustomerConfigurationParameters } from "../../ect-feature/models/customerConfigurationParameters";
import { ConfigurationService } from "../../ect-feature/services/configuration.service";
import {
  Products,
  ProductsNeeded,
} from "../../ect-feature/models/configuration-features";
import { UserDetailActionsModalComponent } from "../user-detail-actions-modal/user-detail-actions-modal.component";
import { FacilityRoleAssignments } from "../models/FacilityRoleAssignments.model";
import { UsesMatrixcareConfirmationDialogComponent } from "../uses-matrixcare-confirmation-dialog/uses-matrixcare-confirmation-dialog.component";
import { UserProfileNameTitleWarningModalComponent } from "../user-profile-name-title-warning-modal/user-profile-name-title-warning-modal.component";

@Component({
  selector: "re-user-detail",
  templateUrl: "./user-detail.component.html",
  styleUrls: ["./user-detail.component.scss"],
  providers: [
    {
      provide: TreeviewEventParser,
      useClass: OrderDownlineTreeviewEventParser,
    },
    { provide: TreeviewConfig, useClass: TreeviewCustomConfig },
  ],
  standalone: false,
})
export class UserDetailComponent implements OnInit {
  @ViewChild(TreeviewComponent, { static: false })
  treeviewComponent: TreeviewComponent;
  user: User = new User();
  alert: Alert;
  showMessage = false;
  emailMessage = true;
  hasGlobalError = false;
  editProfile: boolean;
  canEditProfileAttribute: boolean = false;
  editAccess: boolean = false;
  editAccessSL: boolean = false;
  editAccessMatrixCare: boolean = false;
  editAccessTrueSense: boolean = false;
  editAccessSigmaCare: boolean = false;
  confirmedAccessSL: boolean = false;
  temporaryPassword: string;
  pendingActivation: boolean;
  messageSubscription: Subscription;
  isTwoFactorCollapsed = false;
  editTwoFactor = false;
  updateUserForm: UntypedFormGroup;
  confirmedAccessPD: boolean = false;
  editPdOffice: boolean = false;
  pdOfficeData: Select2Option[];
  editLpcRoles: boolean = false;
  lpcRoleOptions: IMultiSelectOption[] = [];
  editPPRoles: boolean = false;
  editRTORoles: boolean = false;
  ppRoleOptions: IMultiSelectOption[] = [];
  editSolutionsForBusiness: boolean = false;
  solutionsForBusinessModuleOptions: IMultiSelectOption[] = [];
  solutionsForBusinessProductName: string;
  multiSelectSettings = getMultiSelectSettings();
  multiSelectSettingsTexts = getMultiSelectTexts();
  selectedFacilities: any[] = [];
  private reEmailCase =
    /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;
  userAction: any;
  modalReference: NgbModalRef;
  roles: any[];
  disciplines: any[];
  userTypeData: any[];
  adminAccess: string;
  editUserAccess: boolean = false;
  multicareMobile: string;
  customerConfigurationParameters: CustomerConfigurationParameters;
  showMulticareSection: boolean = false;
  multicareMobileEnabled: boolean = false;
  multicareEformsEnabled: boolean = false;
  loading: boolean = false;
  signOnPolicies: string[] = [];
  allPolicies: SignOnPolicy[] = [];
  signOnOptions: IMultiSelectOption[] = [];
  minDate = new Date();
  originalDeactivationDate: any = "";
  showPhysicianNppaCheckbox: boolean = false;
  isPhysicianNppaUser: boolean = false;
  corporateStructureJson: string;
  corporateStructureObject: any;
  physicianNppaTemplates: any[];
  facilitiesForRoleAssignment: { name: string; id: number }[];
  facilityRoles: string[] = [
    "",
    "Cardiologist",
    "Clinical Nurse Specialist",
    "Dentist",
    "Internist",
    "NP/PA",
    "Ophthalmologist",
    "Optometrist",
    "Physician",
    "Podiatrist",
    "Psychiatrist",
    "Psychologist",
    "Urologist",
  ];
  facilityRoleAssignmentForm!: FormGroup;
  isFacilityRoleAssignmentFormLoaded: boolean = false;
  newFacilityRoleAssignments: FacilityRoleAssignments[] = [];
  searchControl = new FormControl("");
  selectAllChecked = false;
  allFacilitiesPreSelected = false;
  facilityListScrolled = false;
  defaultRole = '';
  showSelectAll = false;
  defaultRoleOptions: string[] = [];
  originalFacilityRoleAssignments: {
    role: string;
    name: string;
    checked: boolean;
    id: number;
    accessible: boolean;
  }[];

  adminToolRoleDataDictionary = new Set<string>();
  private _adminToolRoleData: Select2Option[];
  public get adminToolRoleData(): Select2Option[] {
    return this._adminToolRoleData;
  }
  public set adminToolRoleData(value: Select2Option[]) {
    this._adminToolRoleData = value;
    this.adminToolRoleDataDictionary = new Set();
    this.adminToolRoleDataDictionary.clear();
    value.forEach((x) => {
      this.adminToolRoleDataDictionary.add(x.id);
    });
  }

  public mcmdRoleData: Select2Option[] = [];
  public eFormsRoleData: Select2Option[] = [];
  public ppRoleData: Select2Option[] = [];
  public rtoRoleData: Select2Option[] = [];

  savedEmail: string;
  isMfaAccess: boolean = false;

  snfProduct = new ProductInfo(ProductNames.SNF + " Access");
  slProduct = new ProductInfo(ProductNames.SL + " Access");
  caProduct = new ProductInfo(ProductNames.CA + " Access");
  pdProduct = new ProductInfo(ProductNames.PD + " Access");
  lpcProduct = new ProductInfo(ProductNames.LPC + " Access");
  ppProduct = new ProductInfo(ProductNames.PP + " Access");
  rtoProduct = new ProductInfo(ProductNames.RTO + " Access");
  trueSenseProduct = new ProductInfo(ProductNames.TS + " Access");
  sigmaCareProduct = new ProductInfo(ProductNames.SIGMACARE + " Access");
  solutionsForBusinessProduct = new ProductInfo(ProductNames.S4B + " Access");

  isProfileDetailCollapsed: boolean;
  isCustomRole = false;
  corporations: any[];
  careSettings: any[];
  userDetailOptions: RolesDisciplines[];
  userTypeReadOnly = true;
  userTypeReadOnlyForCorp = false;
  isLocationAdmin = false;
  isCustomerAdmin = false;

  // RDL access
  regionsTree: Region[];
  selectedRegions: IUserRegion[];
  corporateLimited = false;
  profileLoading: boolean = true;
  accessLoading: boolean = true;
  enableSLAutoProvisioning: boolean;
  originalConfigId: string;
  usernameDomains: string[];
  selectedFederatedLoginIdDomain: string;
  userPdOfficeData: PdOfficeData;
  //canLmaDeactivateSuspend
  canLmaDeactivateOrSuspendUser: boolean = false;
  config = TreeviewConfig.create({
    hasAllCheckBox: false,
    hasFilter: true,
  });
  public customerFederationEnabled: boolean = false;
  public scimEnabled: boolean = false;
  private profileFieldOriginalValues: {
    firstName: string;
    lastName: string;
    title: string;
  } = {
    firstName: "",
    lastName: "",
    title: "",
  };

  constructor(
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private messageService: MessageService,
    public userService: UserService,
    private router: Router,
    private fb: UntypedFormBuilder,
    private modalService: ModalService,
    private userDetailService: UserDetailService,
    private secSvc: SecurityService,
    private toggleService: ToggleService,
    private transactionLogService: TransactionLogService,
    private userCustomerService: UserCustomerService,
    private securityService: SecurityService,
    private renderer: Renderer2,
    private element: ElementRef,
    private configurationService: ConfigurationService,
    private customerService: CustomerService,
    private modal: ModalService,
  ) {
    this.temporaryPassword = null;
    this.pendingActivation = false; // SMS Factor
    this.adminAccess = ProductNames.AA;
    this.multicareMobile = ProductNames.MCMD;
    this.solutionsForBusinessProductName = ProductNames.S4B;
    this.messageSubscription = this.messageService
      .get()
      .subscribe((message) => {
        // TODO: Refactor this with a better approach.
        if (
          message == MessageType.UserDeleted ||
          message == MessageType.UserCreated
        ) {
          this.showMessage = message; // Expected actions ('CREATED' || 'Delete');
          this.userAction = message;
          this.clearAlerts();
        }
      });
    this.enableSLAutoProvisioning =
      environment.enableSLAutoProvisioning.toLowerCase() === "true";

    //form initializacion should be here to avoid errors when it is being read before oninit
    this.updateUserForm = this.fb.group({
      firstName: ["", Validators.required],
      lastName: ["", Validators.required],
      email: ["", CustomValidators.optionalEmailValidator],
      middleName: [""],
      primaryPhone: ["", Validators.pattern(this.phoneNumPattern)],
      ext: ["", [Validators.pattern(/^\d+$/)]],
      mobilePhone: ["", Validators.pattern(this.phoneNumPattern)],
      userType: [""],
      corporationName: [""],
      careSettingName: [""],
      role: [
        "",
        (_) =>
          RoleDisciplineValidator.validate(this.updateUserForm, this.roles),
      ],
      primaryDiscipline: [
        "",
        (_) =>
          RoleDisciplineValidator.validate(this.updateUserForm, this.roles),
      ],
      adminToolRole: ["RU", Validators.required],
      configId: [""],
      configName: [""],
      solutionsForBusinessModules: [""],
      federatedLoginID: [
        "",
        [
          Validators.maxLength(100),
          (_) => this.federatedLoginIDValidator(this.updateUserForm),
          (control) => this.userNameFormat(control),
        ],
      ],
      slProvisioned: [""],
      trueSenseProvisioned: [""],
      sigmaCareProvisioned: [""],
      sameAsUsername: [],
      title: [],
      prefix: [],
      pdProvisioned: [""],
      officeId: [""],
      customerEmployeeId: [""],
      lpcRoles: [],
      paymentPortalRole: [""],
      rtoRole: [""],
      lpcProvisioned: [""],
      ppProvisioned: [""],
      tokenManagement: [""],
      scimMapping: [""],
      mcmdRole: [""],
      eFormsRole: [""],
      deactivationDate: [""],
      physicianNppaEnabled: false,
      usesMatrixcare: false,
    });

    this.facilityRoleAssignmentForm = this.fb.group({
      checked: false,
      id: [""],
      name: [""],
      role: [""],
    });
  }

  @ViewChild(NgbAccordion, { static: false })
  accordion: NgbAccordion;

  @ViewChild(PhysicianNppaUserChildComponent, { static: false })
  physicianNppaChildComponent: PhysicianNppaUserChildComponent;

  prefixData: Select2OptionData[] = getPrefixesOptions();

  public careSettingName = UserTypeNames.CareSetting;

  public corporateName = UserTypeNames.Corporate;

  public careSettingChanged(careSettingName: string) {
    let currentCorporation = this.getCurrentCorporation();
    if (currentCorporation) {
      let currentFacility: UserDetailOptionsFacility | any =
        currentCorporation.facilities.firstOrDefault(
          (x) => x.name == this.user.careSettingName,
          {},
        );
      let disciplines = currentFacility.disciplines || [];
      this.disciplines = disciplines
        .map((x) => {
          return { text: x, id: x, data: x };
        })
        .sort((a, b) => (a.text > b.text ? 1 : b.text > a.text ? -1 : 0));
      this.userDetailService.addDefaultOption(this.disciplines);
      this.userTypeChanged(false);
    }
  }

  errorCount: number = null;
  refreshErrorCount() {
    this.transactionLogService
      .userHasError(this.route.snapshot.params.id)
      .subscribe((x) => {
        this.errorCount = x;
      });
  }

  private getCurrentCorporation() {
    let currentCorporation = this.userDetailOptions.firstOrDefault(
      (x) =>
        x.configId == this.user.configId && x.name == this.user.corporationName,
    );
    return currentCorporation;
  }

  public corporationChanged(selectedOption: Select2Option) {
    if (!this.user.corporationName || !this.user.corporationName.trim()) {
      this.roles = [];
      this.careSettings = [];
      //dont clear role if phsyician user as they need it to display Facility role assignment form
      if (!this.isPhysicianNppaUser) {
        this.user.role = "";
      }
      this.user.careSettingName = "";
      this.user.primaryDiscipline = "";
      if (
        (this.user.mcmdRole != "Not Selected" &&
          this.user.mcmdRole &&
          this.user.mcmdRole != "") ||
        (this.user.eFormsRole != "Not Selected" &&
          this.user.eFormsRole &&
          this.user.eFormsRole != "")
      ) {
        this.updateUserForm.controls["corporationName"].setErrors({
          mcmdError: true,
        });
      } else {
        this.updateUserForm.controls["corporationName"].setErrors(null);
      }
      return;
    }

    if (!this.originalConfigId && selectedOption) {
      let corp = this.userDetailOptions.firstOrDefault(
        (x) => this.transformCorporationText(x) == selectedOption.text,
      );
      if (corp) {
        this.user.configId = corp.configId;
        this.user.configName = corp.configName;
      }
    }

    this.loadCareSettings();
    this.careSettingChanged(null);
    // if(selectedOption) {
    //   this.checkIfMulticareEnabled(this.user.configId.trim());
    // }
    this.setRoles();
  }

  private loadCareSettings() {
    let currentCorporation = this.getCurrentCorporation();
    if (currentCorporation) {
      this.regionsTree = currentCorporation.regions;
      this.userDetailService.sortRegionsTree(this.regionsTree);
      this.careSettings = currentCorporation.facilities.map((x) => {
        return { text: x.name, id: x.name, data: x };
      });
    }
  }

  public corporationSettings = {
    tags: false,
    placeholder: "Not Selected",
    width: "100%",
    //  createTag: (params) => this.createRoleOption(params)
  };
  public careSettingSettings = {
    tags: false,
    placeholder: "Not Selected",
    width: "100%",
    //  createTag: (params) => this.createRoleOption(params)
  };
  expandAll() {
    this.snfProduct.collapsed = false;
    this.slProduct.collapsed = false;
    this.caProduct.collapsed = false;
    this.pdProduct.collapsed = false;
    this.lpcProduct.collapsed = false;
    this.ppProduct.collapsed = false;
    this.rtoProduct.collapsed = false;
    this.trueSenseProduct.collapsed = false;
    this.sigmaCareProduct.collapsed = false;

    for (let p of Object.keys(this.collapsed)) {
      this.collapsed[p] = false;
    }
  }

  collapsed = {};
  collapseAll() {
    this.snfProduct.collapsed = true;
    this.slProduct.collapsed = true;
    this.caProduct.collapsed = true;
    this.pdProduct.collapsed = true;
    this.lpcProduct.collapsed = true;
    this.ppProduct.collapsed = true;
    this.rtoProduct.collapsed = true;
    this.trueSenseProduct.collapsed = true;
    this.sigmaCareProduct.collapsed = true;

    for (let p of Object.keys(this.collapsed)) {
      this.collapsed[p] = true;
    }
  }
  public isExpanded(panelId: string) {
    let expanded = false;
    this.accordion.panels.forEach((x) => {
      if (x.isOpen && x.id == panelId) expanded = true;
      return false;
    });

    return expanded;
  }
  copySSOID() {
    this.copyToClipboard(this.user.ssoid);
  }

  public copyToClipboard(text) {
    var textArea = document.createElement("textarea");
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.select();

    try {
      var successful = document.execCommand("copy");
      return true;
    } catch (err) {
      console.error("Fallback: Oops, unable to copy", err);
      return false;
    } finally {
      document.body.removeChild(textArea);
    }
  }

  back() {
    if (environment.useLegacyAPI) this.router.navigate(["/users-legacy"]);
    else this.router.navigate(["/users"]);
  }
  private userNameFormat(control: UntypedFormControl) {
    const value = control.value;
    if (!value) return null;

    if (value.indexOf("@") >= 0) {
      return { format: "invalid" };
    }
    return null;
  }
  private phoneNumPattern = /^[2-9][0-9]{9}$/;

  fullFederatedLoginIdUserName() {
    if (this.federationLoginIdEnabled && this.originalFederatedIdentityId) {
      return this.originalFederatedIdentityId;
    }

    return this.user.federatedLoginID;
  }

  sameAsUsernameChanged(value: any) {
    let control = this.updateUserForm.get("federatedLoginID");
    if (value) {
      control.disable();
      let parts = this.user.userName.split("@");
      let username = parts[0];
      control.setValue(username);

      if (parts.length > 1) {
        this.selectedFederatedLoginIdDomain = parts[1];
      }
    } else control.enable();
  }

  mfaEnabled = false;
  isSupportUser = false;
  employeeIdEnabled = false;
  isCorporateLimitedAdmin = false;
  isUserLocationLimitedAdmin = false;
  policiesDictionary = new Map<string, SignOnPolicy>();

  async ngOnInit() {
    window.scrollTo(0, 0);

    this.employeeIdEnabled = environment.employeeIdEnabled;
    this.isLocationAdmin = await this.securityService
      .isUserManagementLocalAdmin()
      .toPromise();
    this.isCorporateLimitedAdmin = await firstValueFrom(
      this.securityService.isCorporateLimitedAdmin(),
    );
    this.securityService
      .isUserLocationLimitedAdmin()
      .subscribe((x) => (this.isUserLocationLimitedAdmin = x));
    this.isCustomerAdmin = await this.securityService
      .isUserManagementCorporateAdmin()
      .toPromise();
    if (!this.isCorporateLimitedAdmin && !this.isUserLocationLimitedAdmin)
      // not required to call transaction log api for limited admins
      this.refreshErrorCount();

    this.isSupportUser = await firstValueFrom(
      this.securityService.isSupportUser(),
    );
    let settings = await firstValueFrom(this.userCustomerService.getSettings());
    this.mfaEnabled = settings.mfaEnabled && settings.customerEnabledMFA;
    const isUserMfaEnabled = await firstValueFrom(
      this.securityService.mfaEnabled(),
    );
    this.isMfaAccess = isUserMfaEnabled && settings.customerEnabledMFA;

    if (this.mfaEnabled) {
      const isCustomerCitusEnabled = await firstValueFrom(
        this.securityService.isCustomerCitusEnabled(),
      );

      let values = await firstValueFrom(this.userService.getSignonPolicies());
      const visiblePolicies = values.filter(
        (policy) =>
          policy &&
          policy.name &&
          !shouldHidePolicy(policy.name, isCustomerCitusEnabled),
      );

      this.allPolicies = visiblePolicies.map((item) => ({
        ...item,
        internalName: item.name.replace(/ /g, "_").toLowerCase(),
      }));

      this.allPolicies.forEach((item) =>
        this.policiesDictionary.set(item.internalName, item),
      );
      this.signOnOptions = this.allPolicies.map<IMultiSelectOption>((x) => {
        return {
          id: x.id,
          name: x.name,
          classes: x.status !== "Active" ? "disableItem" : "",
        };
      });
    }

    this.userService.getMcmdRoles().subscribe((roles) => {
      this.mcmdRoleData = roles.map((x) => {
        return { text: x.name, id: x.name, data: x };
      });
      this.mcmdRoleData.splice(1, this.mcmdRoleData.length - 1);
      this.mcmdRoleData.push({ id: "Not Selected", text: "Not Selected" });
    });

    this.eFormsRoleData = [
      { id: "Not Selected", text: "Not Selected", selected: true },
      { id: "EFormsStaff", text: "eForms Staff" },
      { id: "EFormsAdmin", text: "eForms Admin" },
    ];

    const roles = this.userService.getPPRoleIdText();
    this.ppRoleData = roles.map((x) => ({ text: x.text, id: x.id, data: x }));
    if (!this.ppRoleData.some((x) => x.id === "Not Selected")) {
      this.ppRoleData.unshift({ id: "Not Selected", text: "Not Selected" });
    }

    const rtoRoles = this.userService.getRTORoleIdText();
    this.rtoRoleData = rtoRoles.map((x) => ({ text: x.text, id: x.id, data: x }));
    if (!this.rtoRoleData.some((x) => x.id === "Not Selected")) {
      this.rtoRoleData.unshift({ id: "Not Selected", text: "Not Selected" });
    }

    const toggles = await this.toggleService.get().toPromise();
    this.customerFederationEnabled = toggles.azureADEnabled;
    this.scimEnabled = toggles.scimEnabled;

    this.updateUserForm
      .get("sameAsUsername")
      .valueChanges.subscribe((value) => {
        this.sameAsUsernameChanged(value);
      });

    this.canLmaDeactivateOrSuspendUser = await this.canLmaDeactivateSuspend(
      this.route.snapshot.params.id,
    );

    try {
      this.usernameDomains = await this.secSvc.getAvailableDomains();
      await this.getUser(this.route.snapshot.params.id);
    } catch (e) {
      this.alert = getAlertMessage(e);
      console.error(e);
      this.profileLoading = false;
    }

    const configId = this.user.configId;
    //only for physician nppa users next block
    if (configId && this.user.physicianNppaEnabled) {
      this.showPhysicianNppaCheckbox = true;
      this.isPhysicianNppaUser = true;
      this.userTypeData = [{ text: "Corporate", id: "Corporate" }];
      await this.fetchAndProcessCorporateStructure(configId);
      // Trigger change detection to update the view
      this.cdr.detectChanges();
      // Update validators for title, primaryPhone, and email fields
      this.updateFormFieldValidators(
        this.updateUserForm,
        this.user.physicianNppaEnabled,
      );

      // Build a Set of facility IDs the current user can access (from referenceData, already LMA-filtered)
      const accessibleFacilityIds = new Set<number>();
      for (const option of this.userDetailOptions) {
        if (String(option.configId) === String(this.user.configId)) {
          option.facilities.forEach(f => accessibleFacilityIds.add(f.id));
          break;
        }
      }

      // Use the full facility list from corporateStructureObject (already fetched, not LMA-filtered)
      const allFacilities: { id: number; name: string }[] =
        (this.corporateStructureObject?.facilities || []).map((f: any) => ({ id: f.id, name: f.name }));

      this.facilitiesForRoleAssignment = allFacilities;

      this.facilityRoleAssignmentForm = this.fb.group({
        facilities: this.fb.array(
          allFacilities.map((facility) =>
            this.fb.group({
              checked: false,
              id: [facility.id, Validators.required],
              name: [facility.name, Validators.required],
              role: [""], // Default to an empty if roles are undefined
              originalRole: [""], // Track the original role from API to determine if row should be disabled
              accessible: [!this.isLocationAdmin || accessibleFacilityIds.has(facility.id)],
            }),
          ),
        ),
      });
      // LLA never gets Select All; LMA only if they can access every facility
      this.showSelectAll = this.isCustomerAdmin ||
        (this.isLocationAdmin && !this.isUserLocationLimitedAdmin && accessibleFacilityIds.size === allFacilities.length);
      // Set the flag to true after the form is initialized
      this.isFacilityRoleAssignmentFormLoaded = true;

      // Load facility roles into the form
      try {
        this.loadFacilityRoles();
      } catch (error) {
        console.error("Error in loadfacilityRoles:", error);
      }

      // Initialize the `visible` property for each facility
      this.facilities.controls.forEach((control) => {
        if (!control.get("visible")) {
          (control as FormGroup).addControl("visible", new FormControl(true));
        }
      });

      // Update the `visible` property based on the search term
      this.searchControl.valueChanges.subscribe((searchTerm: string) => {
        const facilities = this.facilities.controls;
        facilities.forEach((control) => {
          const facilityName = control.get("name")?.value?.toLowerCase() || "";
          const matches = facilityName.includes(searchTerm.toLowerCase());
          control.get("visible")?.setValue(matches);
        });
      });

      this.cdr.detectChanges();
    }
  }

  get facilities(): FormArray {
    return this.facilityRoleAssignmentForm.get("facilities") as FormArray;
  }

  private async fetchAndProcessCorporateStructure(
    configId: string,
  ): Promise<void> {
    try {
      let corporateStructure = await this.customerService
        .getCorporateStructureByConfigId(configId)
        .toPromise();

      // Convert to JSON string for debugging or inspection
      this.corporateStructureJson = JSON.stringify(corporateStructure);
      // Parse back to JSON object (if needed)
      this.corporateStructureObject = JSON.parse(this.corporateStructureJson);
      // Extract specific fields (e.g., roles)
      this.physicianNppaTemplates = this.corporateStructureObject?.roles || [];
      this.physicianNppaTemplates = this.physicianNppaTemplates.filter(
        (role) =>
          role.specialUserTokenDesc?.toLowerCase() ===
            "specialuser:physician".toLowerCase() ||
          role.specialUserTokenDesc?.toLowerCase() ===
            "specialuser:nppa".toLowerCase(),
      );
    } catch (error) {
      console.error("Error fetching corporate structure:", error);
    }
  }

  federatedLoginIDValidator(form: UntypedFormGroup): ValidationErrors | any {
    if (!this.federationLoginIdEnabled) return null;

    if (!this.user.federatedIdentity) return null;

    let federatedLoginID = form.get("federatedLoginID").value;
    if (federatedLoginID) return null;

    return { required: true };
  }

  private validateProductRoleSelection(controlName: string, value: any): void {
    this.updateUserForm.controls[controlName].setErrors(null);

    const hasRole = this.user.role && this.user.role.trim();
    let hasValue = false;

    // Check if the field has a meaningful value
    if (Array.isArray(value)) {
      hasValue = value.length > 0;
    } else {
      hasValue = value && value !== "Not Selected" && value.trim() !== "";
    }

    if (!hasRole && hasValue) {
      this.updateUserForm.controls[controlName].setErrors({ invalid: true });
    }
  }

  public mcmdRoleChanged() {
    this.validateProductRoleSelection("mcmdRole", this.user.mcmdRole);
  }

  public eFormsRoleChanged() {
    this.validateProductRoleSelection("eFormsRole", this.user.eFormsRole);
  }

  public solutionsForBusinessModulesChanged() {
    this.validateProductRoleSelection(
      "solutionsForBusinessModules",
      this.user.solutionsForBusinessModules,
    );
  }

  public paymentPortalRoleChanged() {
    this.validateProductRoleSelection("paymentPortalRole", this.user.paymentPortalRole);
  }

  public rtoRoleChanged() {
    this.validateProductRoleSelection("rtoRole", this.user.rtoRole);
  }

  private isUserTypeReadOnly(): boolean {
    return (
      this.user.userType === UserTypeNames.Corporate ||
      this.user.userType === UserTypeNames.CareSetting
    );
  }

  public isDisciplineRequired = true;

  public roleChanged(roleName) {
    this.checkRDLAccess();
    if (!this.user.role || !this.user.role.trim()) return;
    this.mcmdRoleChanged();
    this.eFormsRoleChanged();
    this.solutionsForBusinessModulesChanged();
    this.paymentPortalRoleChanged();
    this.rtoRoleChanged();
    this.setDiscipline();
    if (!this.isDisciplineRequired) {
      this.user.primaryDiscipline = null;
    }
    setTimeout(
      () =>
        this.userService.createRDLSearchClearButton(
          this.element,
          this.renderer,
          this.treeviewComponent,
        ),
      100,
    );
  }

  private checkRDLAccess() {
    this.corporateLimited = false;
    if (this.user.userType === UserTypeNames.Corporate) {
      let role = getRoleFromName(this.roles, this.user.role);
      if (role) {
        this.corporateLimited = role.corporateLimited;
        if (this.corporateLimited) {
          this.setSelectedRegions();
        }
      }
    }
  }

  public userTypeChanged(resetUserInfo = true) {
    //lets reset the info now so it tirggers the validation
    if (resetUserInfo) {
      this.user.role = null;
      this.user.primaryDiscipline = null;
      this.selectedRegions = null;
    }

    this.setRoles();

    this.roleChanged(null);

    if (this.user.userType != this.careSettingName) {
      this.user.careSettingName = null;
      this.user.primaryDiscipline = null;
    }
  }

  private setRoles() {
    let roles = [];
    let disciplines = [];

    let currentCorporation = this.getCurrentCorporation();
    if (!currentCorporation) return;

    let currentFacility: UserDetailOptionsFacility | any =
      currentCorporation.facilities.firstOrDefault(
        (x) => x.name == this.user.careSettingName,
        {},
      );

    //Had to add and statement because we are forcing usertype to corporate for physician nppa users
    //but need to load special user templates for the roles array
    if (
      this.user.userType == UserTypeNames.Corporate &&
      !this.isPhysicianNppaUser
    ) {
      roles = currentCorporation.roles;
    } else if (this.user.userType == UserTypeNames.CareSetting) {
      roles = currentFacility.roles;
    } else if (this.user.physicianNppaEnabled) {
      roles = this.physicianNppaTemplates;
    }

    roles = roles || [];

    this.roles = roles.map((x) => {
      return { text: x.name, id: x.name, data: x };
    });
    this.userDetailService.addDefaultOption(this.roles);
  }

  public federationLoginIdEnabled = false;
  public azureADEnabled = false;

  private async loadOptions() {
    try {
      this.alert = null;
      this.accessDisabled = false;
      this.accessDisabledSL = false;

      if (this.isPhysicianNppaUser) {
        this.userTypeData = [{ text: "Corporate", id: "Corporate" }];
      } else {
        this.userTypeData = await this.userDetailService.getUserTypes();
      }
      this.userDetailService.addDefaultOption(this.userTypeData);

      this.adminToolRoleData =
        await this.userService.getUserAccessTypesOptions(true);

      await this.userAccessTypeChanged(false);

      const toggles = await this.toggleService.get().toPromise();

      this.federationLoginIdEnabled = toggles.federatedLoginIdEnabled;
      this.azureADEnabled = toggles.azureADEnabled;

      await this.userDetailService
        .getOptions()
        .pipe(
          map((x) => {
            $(function () {
              $('[data-toggle="tooltip"]')["tooltip"]();
            });

            this.userDetailOptions = x;

            this.setUserEnvironmentName();
            this.corporations = this.userDetailOptions
              .filter(
                (x) => !this.user.configId || x.configId == this.user.configId,
              )
              .map((x) => {
                return {
                  text: this.transformCorporationText(x),
                  id: x.name,
                  data: x,
                };
              });
          }),
        )
        .toPromise();

      await this.loadProductOptions();
      //exclude LMA for Non-SNF customers
      if (!this.snfProduct.display) {
        this.adminToolRoleData = this.adminToolRoleData.filter(
          (x) => x.id != "LMA" && x.id != "LLA",
        );
      }
      this.userDetailService.addDefaultOption(this.corporations);

      //trigger change detection after product options are loaded
      this.cdr.detectChanges();

      // set selected user access
      this.corporationChanged(null);
      //this.userTypeChanged(false);
      this.roleChanged(null);
      this.addCustomData(this.roles, this.user.role);
      this.addCustomData(this.disciplines, this.user.primaryDiscipline);
      this.setDiscipline();
      this.userTypeReadOnly = this.isUserTypeReadOnly();
      this.setSelectedRegions();

      this.accessLoading = false;
      if (this.user.configId && this.pdProduct.display) {
        this.userDetailService.getPdOffices(this.user.configId).subscribe(
          (dl) => {
            this.pdOfficeData = dl.map((x) => {
              return { text: x.name, id: x.id.toString() };
            });
          },
          (error) => {
            this.messageService.sendError(getAlertMessage(error).message);
          },
        );
      }

      if (this.user.configId && this.lpcProduct.display) {
        this.userDetailService.getLpcRoles(this.user.configId).subscribe(
          (lr) => {
            this.lpcRoleOptions = lr.map<IMultiSelectOption>((x) => {
              return { id: x.roleName, name: x.roleName };
            });
          },
          (error) => {
            this.messageService.sendError(getAlertMessage(error).message);
          },
        );
      }

      if (this.mfaEnabled && !this.user.federatedIdentity && this.user.factor) {
        const filteredPolicies = this.allPolicies.filter((o1) => {
          return this.user.factor.signOnPolicyList.some(
            (o2) => o2.name === o1.internalName,
          );
        });
      }
    } catch (e) {
      this.accessDisabled = true;
      this.accessDisabledSL = true;
      this.accessLoading = false;
      this.alert = new Alert(
        AlertType.WARNING,
        "The Access section on this page is temporarily not available.",
      );
      console.error(e);
    } finally {
      this.snfProduct.loading = false;
      this.slProduct.loading = false;
      this.trueSenseProduct.loading = false;
    }
  }

  private originalFederatedIdentityId = "";
  public federatedUserName: string;
  private extractFederatedLoginDomain(user: User = null) {
    if (!user) user = this.user;

    this.federatedUserName = user.federatedLoginID;
    this.selectedFederatedLoginIdDomain = null;
    if (user.federatedIdentity && user.federatedLoginID) {
      let parts = user.federatedLoginID.split("@");
      this.federatedUserName = parts[0];
      if (parts.length > 1) {
        this.selectedFederatedLoginIdDomain = parts[1];
      }
    }
  }

  private setUserEnvironmentName() {
    let environmentName = "";
    if (this.user.configId) {
      let env = this.userDetailOptions.firstOrDefault(
        (x) => x.configId == this.user.configId,
      );
      if (env) {
        environmentName = env.configName;
      } else {
        console.error(`Environment ${this.user.configId} not found.`);
      }
    } else {
      if (this.user.corporationName) {
        let corp = this.userDetailOptions.firstOrDefault(
          (x) => x.name == this.user.corporationName,
        );
        if (corp) {
          this.user.configId = corp.configId;
          environmentName = corp.configName;
        } else {
          console.error(
            `Corporation '${this.user.corporationName}' not found.`,
          );
        }
      }
    }
    this.user.configName = environmentName;
  }

  private transformCorporationText(role: RolesDisciplines) {
    return `${role.name} (  ${role.configName} )`;
  }

  public checkProductAccess(key: string) {
    switch (key) {
      case Products.CITUS:
        this.multicareMobileEnabled = true;
        this.showMulticareSection = true;
        break;
      case Products.EFORMS:
        this.multicareEformsEnabled = true;
        this.showMulticareSection = true;
        break;
      case Products.SL:
        this.enableSLAutoProvisioning = true;
        break;
      default:
        break;
    }
  }

  async loadProductOptions() {
    let value = await this.configurationService
      .getConfigurationFeaturesByConfigId(this.user.configId)
      .toPromise();
    var ssoid = this.route.snapshot.params.id;

    let productsNeeded: ProductsNeeded[] = value.productsNeeded;
    value.productsNeeded.forEach((element) =>
      this.checkProductAccess(element["key"]),
    );
    value.sharedComponents.forEach((key) => this.checkProductAccess(key));
    if (value.sharedComponents.includes("bp.idm.auth.physician.enabled")) {
      this.showPhysicianNppaCheckbox = true;
    } else {
      this.showPhysicianNppaCheckbox = false;
    }

    if (
      value.productsNeeded.some(
        (product) => product.key === "sb.module.enabled",
      )
    ) {
      this.solutionsForBusinessModuleOptions = [];
      if (
        value.productsNeeded.some(
          (product) => product.key === "sb.module.efa.enabled",
        )
      ) {
        this.solutionsForBusinessModuleOptions.push({
          id: "EntranceFeeAmortization",
          name: "Entrance Fee Amortization",
        });
      }
      if (
        value.productsNeeded.some(
          (product) => product.key === "sb.module.pnsm.enabled",
        )
      ) {
        this.solutionsForBusinessModuleOptions.push({
          id: "ParkingStorageManagement",
          name: "Parking & Storage Management",
        });
      }
    }

    const SNFObject = productsNeeded.find((e) => e.key === Products.SNF);
    const SLObject = productsNeeded.find((e) => e.key === Products.SL);
    const PDObject = productsNeeded.find((e) => e.key === Products.PD);
    const LPCObject = productsNeeded.find((e) => e.key === Products.LPC);
    const PPObject = productsNeeded.find((e) => e.key === Products.PP);
    const RTOObject = productsNeeded.find((e) => e.key === Products.RTO);
    const S4BObject = productsNeeded.find((e) => e.key === Products.S4B);
    const SIGMACAREObject = productsNeeded.find((e) => e.key === Products.SIGMACARE);

    const TSEnabled = value.ssoIntegrations?.includes(Products.TS);

    if (SNFObject) {
      // if (obj.SNF.deepLink)
      // this.snfProduct.editUserUrl = `${obj.SNF.deepLink}/someUrl?ssoid=${ssoid}`;
      // this.snfProduct.userStatus = obj.SNF.status;
      this.snfProduct.userStatus = UserStatus.Provisioned;
      this.snfProduct.display = true;
    }

    if (SLObject) {
      this.slProduct.display = true;
      this.slProduct.editUserUrl = `${SLObject.value}/HomeSSO/Redirect?mxtype=ADMINTOOLAPI&ssoid=${ssoid}&type=1`;
      if (this.confirmedAccessSL) {
        this.slProduct.userStatus = UserStatus.Provisioned;
      }
    }

    if (PDObject) {
      this.pdProduct.display = true;
      if (this.user.configId && this.user.userName) {
        this.userDetailService
          .getUserPdOffice(
            this.user.configId,
            this.user.userName,
            this.user.ssoid,
          )
          .subscribe(
            (dl) => {
              this.userPdOfficeData = dl;
              this.user.officeId = dl?.id.toString();
            },
            (error) => {
              if (error.status != 404) {
                this.messageService.sendError(getAlertMessage(error).message);
              }
            },
          );
      } else {
        // this.userPdOfficeData = new PdOfficeData();
        // this.userPdOfficeData.name = "Not Selected";
      }
    }

    if (LPCObject) {
      this.lpcProduct.display = true;
      if (this.user.configId) {
        this.userDetailService.getLpcRoles(this.user.configId).subscribe(
          (lr) => {
            this.lpcRoleOptions = lr.map<IMultiSelectOption>((x) => {
              return { id: x.roleName, name: x.roleName };
            });
          },
          (error) => {
            if (error.status != 404) {
              this.messageService.sendError(getAlertMessage(error).message);
            }
          },
        );
      }
    }

    if (PPObject) {
      this.ppProduct.display = true;
      this.user.ppProvisioned = true;
    }

    if (RTOObject) {
      this.rtoProduct.display = true;
    }

    if (TSEnabled) {
      this.trueSenseProduct.display = true;
    }

    if (S4BObject) {
      this.solutionsForBusinessProduct.display = true;
    }

    if (SIGMACAREObject) {
      this.sigmaCareProduct.display = true;
    }

    //next release?
    //if (obj.CA) {
    // this.slProduct.display = true;
    //  if (obj.CA.deepLink)
    //    this.slProduct.editUserUrl = `${obj.CA.deepLink}/editUser?ssoid=${ssoid}`;
    //  this.caProduct.userStatus = obj.CA.status;
    //}
  }

  public accessDisabled = false;
  public accessDisabledSL = false;

  clearAlerts() {
    this.hasGlobalError = false;
    this.pendingActivation = false;
    this.alert = null;
    setTimeout(() => (this.showMessage = false), 5000);
  }

  resettingFactor = false;

  async resetFactor() {
    const dialog =
      this.modalService.create<TwoFactorResetConfirmtionDialogComponent>(
        TwoFactorResetConfirmtionDialogComponent,
      );
    if (await dialog.modalRef.result) {
      this.resettingFactor = true;
      this.userService.resetFactors(this.user.ssoid).subscribe(
        () => {
          this.alert = new Alert(
            AlertType.SUCCESS,
            "All factors have been reset.",
          );
          this.resettingFactor = false;
        },
        (err) => {
          this.messageService.send(getAlertMessage(err));
          this.resettingFactor = false;
        },
      );
    }
  }
  cancelTwoFactor() {
    this.signOnPolicies = [];
    this.editTwoFactor = false;
  }

  updateTwoFactor() {
    this.updateUserProfile();
    this.editTwoFactor = false;
  }

  private policyMatchesAssignment(
    policy: SignOnPolicy,
    assignedPolicy?: SignOnPolicyAssignment,
  ): boolean {
    if (!assignedPolicy) {
      return false;
    }

    return Boolean(
      (policy.id && assignedPolicy.id && policy.id === assignedPolicy.id) ||
        assignedPolicy.name === policy.internalName ||
        assignedPolicy.name === policy.name ||
        assignedPolicy.internalName === policy.internalName,
    );
  }

  private getAssignedEditablePolicies(
    assignedPolicies: SignOnPolicyAssignment[] = this.user.factor
      ?.signOnPolicyList || [],
  ): SignOnPolicy[] {
    if (!assignedPolicies.length || !this.allPolicies.length) {
      return [];
    }

    return this.allPolicies.filter((policy) =>
      assignedPolicies.some((assignedPolicy) =>
        this.policyMatchesAssignment(policy, assignedPolicy),
      ),
    );
  }

  private syncSelectedSignOnPolicies(
    assignedPolicies: SignOnPolicyAssignment[] = this.user.factor
      ?.signOnPolicyList || [],
  ): void {
    this.signOnPolicies = this.getAssignedEditablePolicies(assignedPolicies)
      .map((policy) => policy.id)
      .filter((policyId): policyId is string => !!policyId);
  }

  private buildSignOnPolicyPayload(
    assignedPolicies: SignOnPolicyAssignment[] = [],
  ): SignOnPolicyAssignment[] {
    const preservedPolicies = assignedPolicies.filter(
      (assignedPolicy) =>
        !this.allPolicies.some((policy) =>
          this.policyMatchesAssignment(policy, assignedPolicy),
        ),
    );

    const selectedPolicies = this.allPolicies
      .filter((policy) =>
        this.signOnPolicies.some((selectedId) => policy.id === selectedId),
      )
      .map<SignOnPolicyAssignment>((policy) => ({
        id: policy.id,
        description: policy.description,
        status: policy.status,
        priority: policy.priority,
        active: policy.active,
        mfaEnabled: policy.mfaEnabled,
          name: policy.internalName,
      }));

    return [...preservedPolicies, ...selectedPolicies];
  }

  twoFactorClicked() {
    this.syncSelectedSignOnPolicies();
    this.editTwoFactor = true;
  }

  editProfileClicked() {
    this.editProfile = true;
    this.canEditProfileAttribute = !this.user.federatedIdentity;
    this.minDate = new Date();

    this.profileFieldOriginalValues = {
      firstName: this.user.firstName || "",
      lastName: this.user.lastName || "",
      title: this.user.title || "",
    };
  }

  private hasNameOrTitleChanges(): boolean {
    return (["firstName", "lastName", "title"] as const).some(
      (fieldName) =>
        (this.user[fieldName] || "") !==
        (this.profileFieldOriginalValues[fieldName] || ""),
    );
  }

  private async confirmNameTitleChanges(): Promise<boolean> {
    const modal = this.modalService.create<UserProfileNameTitleWarningModalComponent>(
      UserProfileNameTitleWarningModalComponent,
      {
        backdrop: "static",
      },
    );

    return modal.modalRef.result.catch(() => false);
  }

  private revertNameTitleFields(): void {
    (["firstName", "lastName", "title"] as const).forEach((fieldName) => {
      const originalValue = this.profileFieldOriginalValues[fieldName] || "";
      this.user[fieldName] = originalValue;
      this.updateUserForm.get(fieldName)?.setValue(originalValue);
    });
  }

  editUserAccessClicked() {
    this.editUserAccess = true;
  }

  editAccessClicked() {
    this.editAccess = true;
    this.setRoles();
    if (this.user.userType === UserTypeNames.Corporate) {
      this.userTypeReadOnlyForCorp = true;
    }

    if (this.isPhysicianNppaUser) {
      const facilitiesArray = this.facilityRoleAssignmentForm.get(
        "facilities",
      ) as FormArray;

      // Save original values before making any changes
      this.originalFacilityRoleAssignments = facilitiesArray.controls.map(
        (control) => ({
          checked: control.get("checked")?.value,
          id: control.get("id")?.value,
          name: control.get("name")?.value,
          role: control.get("role")?.value,
          accessible: !!control.get("accessible")?.value,
        }),
      );

      // Seed newFacilityRoleAssignments with all pre-existing checked assignments so
      // that assignments the user does not touch in the UI are not dropped on save.
      this.newFacilityRoleAssignments = facilitiesArray.controls
        .filter(
          (control) =>
            control.get("checked")?.value && control.get("role")?.value,
        )
        .map((control) => ({
          id: control.get("id")?.value,
          role: control.get("role")?.value,
        }));

      //this next block is to set disabled property on the checkbox and role dropdown
      //based on accessibility, existing assignment state, and original role
      facilitiesArray.controls.forEach(
        (control: AbstractControl, index: number) => {
          const isChecked = control.get("checked")?.value;
          const originalRole = control.get("originalRole")?.value;
          const isAccessible = !!control.get("accessible")?.value;
          const checkboxControl = control.get("checked");
          const roleControl = control.get("role");

          // If original role was "Physician", keep both checkbox and role disabled
          if (originalRole === "Physician") {
            checkboxControl?.disable({ emitEvent: false });
            roleControl?.disable({ emitEvent: false });
          } else if (!isAccessible) {
            // LMA does not have access to this facility — disable checkbox and role.
            // [attr.disabled] alone cannot override an Angular reactive FormControl that
            // has been .enable()d, so we must call .disable() here.
            checkboxControl?.disable({ emitEvent: false });
            roleControl?.disable({ emitEvent: false });
          } else {
            // Accessible facility
            if (isChecked) {
              checkboxControl?.disable({ emitEvent: false });
              roleControl?.enable({ emitEvent: false });
            } else {
                  checkboxControl?.enable({ emitEvent: false });
                  // Role stays disabled until the facility is checked — the FormControl's
                  // native disabled state overrides the template [disabled] attribute.
                  roleControl?.disable({ emitEvent: false });
            }
          }
        },
      );

      this.deriveSelectAllState();

      // Trigger change detection first
      this.cdr.detectChanges();

      // After change detection, force role values to refresh in select2 components
      setTimeout(() => {
        facilitiesArray.controls.forEach((control: AbstractControl) => {
          const roleControl = control.get("role");
          const currentRoleValue = roleControl?.value;

          if (currentRoleValue) {
            // Re-set the value to force select2 to update its display
            roleControl?.setValue(currentRoleValue);
          }
        });
      }, 0);
    }
  }

  editAccessMatrixCareClicked() {
    if (!this.isSupportUser) {
      this.editAccessMatrixCare = true;
    }
  }

  editSLAccessClicked() {
    this.editAccessSL = true;
    this.user.slProvisioned = true;
  }

  editTrueSenseAccessClicked() {
    this.editAccessTrueSense = true;
    this.user.trueSenseProvisioned = true;
  }

  editSigmaCareAccessClicked() {
    this.editAccessSigmaCare = true;
  }

  editPdOfficeClicked() {
    this.editPdOffice = true;
  }

  savePdOffice() {
    this.user.pdProvisioned = true;
    this.updateUserProfile();
    this.editPdOffice = false;
  }

  cancelEditPdOfficeClicked() {
    this.editPdOffice = false;
  }

  editLpcRolesClicked() {
    this.editLpcRoles = true;
  }

  editPPRolesClicked() {
    this.editPPRoles = true;
  }

  editRTORolesClicked() {
    this.editRTORoles = true;
  }

  editSolutionsForBusinessClicked() {
    this.editSolutionsForBusiness = true;
  }
  saveLpcRoles() {
    this.user.lpcProvisioned = true;
    this.updateUserProfile();
    this.editLpcRoles = false;
  }
  savePPRoles() {
    this.user.ppProvisioned = true;
    this.updateUserProfile();
    this.editPPRoles = false;
  }

  saveRTORoles() {
    this.updateUserProfile();
    this.editRTORoles = false;
  }

  cancelEditLpcRolesClicked() {
    this.editLpcRoles = false;
    this.getUser(this.user.ssoid, false);
  }
  cancelEditPPRolesClicked() {
    this.editPPRoles = false;
    this.getUser(this.user.ssoid, false);
  }

  cancelEditRTORolesClicked() {
    this.editRTORoles = false;
    this.getUser(this.user.ssoid, false);
  }

  cancelEditSolutionsForBusinessClicked() {
    this.editSolutionsForBusiness = false;
    this.getUser(this.user.ssoid, false);
  }

  saveSolutionsForBusiness() {
    this.updateUserProfile();
  }

  getSelectedSolutionsForBusinessModules(): string {
    if (
      !this.user.solutionsForBusinessModules ||
      this.user.solutionsForBusinessModules.length === 0
    ) {
      return "None selected";
    }

    const moduleNames = this.user.solutionsForBusinessModules.map(
      (moduleId) => {
        switch (moduleId) {
          case "EntranceFeeAmortization":
            return "Entrance Fee Amortization";
          case "ParkingStorageManagement":
            return "Parking & Storage Management";
          default:
            return moduleId;
        }
      },
    );

    return moduleNames.join(", ");
  }

  async resetProfileFlags() {
    this.editProfile = false;
    this.canEditProfileAttribute = false;

    // Reload original data from server
    await this.getUser(this.user.ssoid, false);

    // Force the view to render the reloaded user data so the physician-nppa child
    // component (behind *ngIf) exists before we call into it below.
    this.cdr.detectChanges();
    if (this.physicianNppaChildComponent) {
      // Trigger the child component to rebuild its FormArray with the original user data
      this.physicianNppaChildComponent.setStateDeaNumbers();

      // Ensure at least one blank field is displayed
      this.physicianNppaChildComponent.ensureAtLeastOneStateDeaNumber();

      // Trigger validation refresh to ensure clean state
      this.physicianNppaChildComponent.validateAllDeaNumbers();
    }
    if (this.isFacilityRoleAssignmentFormLoaded && !this.isPhysicianNppaUser) {
      this.facilityRoleAssignmentForm.reset(); // Resets the form to its initial state
      this.isFacilityRoleAssignmentFormLoaded = false; // Optionally reset the flag
    }
  }
  resetUserAccessFlags() {
    this.editUserAccess = false;
    this.getUser(this.user.ssoid, false);
  }
  resetAccessFlags() {
    this.editAccess = false;
    this.getUser(this.user.ssoid, false);
    this.resetFacilityRoleAssignmentForm();
  }
  resetFacilityRoleAssignmentForm() {
    const facilitiesArray = this.fb.array(
      this.originalFacilityRoleAssignments.map((facility) =>
        this.fb.group({
          checked: [facility.checked],
          id: [facility.id],
          name: [facility.name],
          role: [facility.role],
          accessible: [facility.accessible],
          originalRole: [facility.role],
          visible: [true],
        }),
      ),
    );

    this.facilityRoleAssignmentForm.setControl("facilities", facilitiesArray);
    // Re-apply the disabled state for physician NPPA users
    if (this.isPhysicianNppaUser) {
      facilitiesArray.controls.forEach((control: AbstractControl) => {
        const isChecked = control.get("checked")?.value;
        const originalRole = control.get("originalRole")?.value;
        const isAccessible = !!control.get("accessible")?.value;
        const checkboxControl = control.get("checked");
        const roleControl = control.get("role");

        if (originalRole === "Physician" || !isAccessible) {
          checkboxControl?.disable({ emitEvent: false });
          roleControl?.disable({ emitEvent: false });
        } else if (isChecked) {
          checkboxControl?.disable({ emitEvent: false });
          roleControl?.enable({ emitEvent: false });
        } else {
          checkboxControl?.enable({ emitEvent: false });
          // Role stays disabled until the facility is checked.
          roleControl?.disable({ emitEvent: false });
        }
      });
    }

    this.newFacilityRoleAssignments = [];
    this.deriveSelectAllState();
    this.cdr.detectChanges();
    // Force select2 to re-render reverted values (including empty ones)
    setTimeout(() => {
      const arr = this.facilityRoleAssignmentForm.get('facilities') as FormArray;
      arr.controls.forEach((control: AbstractControl) => {
        const roleControl = control.get('role');
        roleControl?.setValue(roleControl.value);
      });
    }, 0);
  }
  resetAccessMatrixCareFlags() {
    this.editAccessMatrixCare = false;
    this.getUser(this.user.ssoid, false);
  }
  resetAccessFlagsSL() {
    this.editAccessSL = false;
    this.getUser(this.user.ssoid, false);
  }
  saveSLAccessClicked() {
    this.updateUserProfile();
  }
  resetAccessFlagsTrueSense() {
    this.editAccessTrueSense = false;
    this.getUser(this.user.ssoid, false);
  }

  resetAccessFlagsSigmaCare() {
    this.editAccessSigmaCare = false;
    this.getUser(this.user.ssoid, false);
  }

  resetAccessFlagsSolutionsForBusiness() {
    this.editSolutionsForBusiness = false;
    this.getUser(this.user.ssoid, false);
  }
  saveTrueSenseAccessClicked() {
    this.updateUserProfile();
    this.editAccessTrueSense = false;
  }

  saveSigmaCareAccessClicked() {
    this.updateUserProfile();
    this.editAccessSigmaCare = false;
  }

  // TODO: Make use of the functions available in user-list component with component to component interaction to avoid code duplication
  async updateUserProfile(): Promise<void> {
    this.saveUserProfile();
  }

  private saveUserProfile(): void {
    this.messageService.send(MessageType.ProcessingOn);
    this.userAction = "Edit Profile";

    if (!this.user.deactivationDate && this.originalDeactivationDate) {
      this.user.deactivationDate = "";
    }

    if (!this.isDisciplineRequired) this.user.primaryDiscipline = null;

    if (!this.corporateLimited) {
      this.selectedRegions = null;
    }
    // Fix for IDM-5857. selectedRegions will always be empty when the profile details are updated; therefore the user regions were cleared when the profile details were updated.
    this.user.userRegions = this.editAccess
      ? this.selectedRegions
      : this.user.userRegions;
    this.setSelectedRegions();
    if (!this.user.mcmdRole || this.user.mcmdRole === "Not Selected") {
      this.user.mcmdRole = "";
    }
    if (!this.user.eFormsRole || this.user.eFormsRole === "Not Selected") {
      this.user.eFormsRole = "";
    }
    if (
      !this.user.paymentPortalRole ||
      this.user.paymentPortalRole === "Not Selected"
    ) {
      this.user.paymentPortalRole = "";
    }
    if (
      !this.user.rtoRole ||
      this.user.rtoRole === "Not Selected"
    ) {
      this.user.rtoRole = "";
    }
    if (this.user.deactivationDate) {
      this.user.deactivationDate = this.user.deactivationDate
        .toISOString()
        .split("T")[0];
    }
    const stateDeaNumbersArray =
      this.updateUserForm.get("stateDeaNumbers")?.value;
    if (stateDeaNumbersArray) {
      const validEntries = stateDeaNumbersArray.filter((entry: any) => {
        return entry.stateForDeaNumber?.trim() || entry.deaNumber?.trim();
      });

      this.user.stateDeaNumbers = validEntries;
    }

    if (
      this.newFacilityRoleAssignments &&
      this.newFacilityRoleAssignments.length > 0
    ) {
      this.user.facilityRoleAssignments = this.newFacilityRoleAssignments;
    }

    let usercopy: User = JSON.parse(JSON.stringify(this.user));
    //the default option has the id of ' '
    if (usercopy.userType) usercopy.userType = usercopy.userType.trim();

    if (usercopy.role) usercopy.role = usercopy.role.trim();

    if (usercopy.corporationName)
      usercopy.corporationName = usercopy.corporationName.trim();

    if (usercopy.primaryDiscipline)
      usercopy.primaryDiscipline = usercopy.primaryDiscipline.trim();

    if (!usercopy.email.trim()) {
      usercopy.email = this.userService.getDummyEmail();
    }

    if (this.mfaEnabled && !usercopy.federatedIdentity && usercopy.factor) {
      usercopy.factor.signOnPolicyList = this.buildSignOnPolicyPayload(
        usercopy.factor.signOnPolicyList || [],
      );

      console.log("usercopy.factor", usercopy.factor);
    }

    this.userTypeReadOnly = this.isUserTypeReadOnly();

    // NOTE: The back-end cannot handle the sending of the slProvisioned flag as TRUE if the existing record value is
    //       already set to true. The slProvisioned flag can ONLY be set to TRUE by the checking of the checkbox within the UI.
    //       The originating value is stored in the confirmAccessSL flag so this value is used to determine if the slProvisioned
    //       flag needs to be set to FALSE on the SAVE action during an EDIT.
    if (this.confirmedAccessSL) {
      usercopy.slProvisioned = false;
    }

    if (
      this.federationLoginIdEnabled &&
      usercopy.federatedIdentity &&
      this.federatedUserName &&
      this.selectedFederatedLoginIdDomain
    ) {
      usercopy.federatedLoginID = `${this.federatedUserName}@${this.selectedFederatedLoginIdDomain}`;
    }

    if (!(usercopy.paymentPortalRole || "").trim()) {
      usercopy.paymentPortalRole = "";
    }
    //so it display the previosly saved one, while is loading the user
    this.originalFederatedIdentityId = usercopy.federatedLoginID;
    if (this.updateUserForm.get("primaryDiscipline")) {
      this.updateUserForm.get("primaryDiscipline").setErrors(null);
    }
    this.userService
      .updateUser(
        usercopy,
        environment.enableSLAutoProvisioning.toLowerCase() === "true",
      )
      .subscribe(
        (res) => {
          // If user was updated successfully, ssoid must have some value.
          if (res.ssoid != null && res.ssoid.length > 0) {
            this.editAccess = false;
            this.editAccessMatrixCare = false;
            this.editUserAccess = false;
            this.editProfile = false;
            this.canEditProfileAttribute = false;
            this.editSolutionsForBusiness = false;

            this.getUser(this.user.ssoid);

            this.showMessage = true;
            window.scroll(0, 0);
            this.clearAlerts();
            this.editAccessSL = false;
          }
          if (this.treeviewComponent) {
            this.treeviewComponent.onFilterTextChange("");
          }
          this.messageService.send(MessageType.ProcessingOff);
        },
        (err) => {
          if (this.treeviewComponent) {
            this.treeviewComponent.onFilterTextChange("");
          }
          this.messageService.send(MessageType.ProcessingOff);
          this.alert = getAlertMessage(err);
        },
      );
  }
  async convertToFederated() {
    let modal =
      await this.modalService.create<UserConversionToFederationConfirmationDialogComponent>(
        UserConversionToFederationConfirmationDialogComponent,
      );
    modal.component.federationLoginIdEnabled = this.federationLoginIdEnabled;
    modal.component.userName = this.user.userName;
    modal.component.usernameDomains = this.usernameDomains;

    if (await modal.modalRef.result) {
      this.messageService.showSpinner();
      this.userService
        .convertToFederated(this.user.ssoid, modal.component.federatedLoginID)
        .subscribe(
          async (_) => {
            await this.getUser(this.user.ssoid);
            this.messageService.hideSpinner();
          },
          (err) => {
            this.messageService.hideSpinner();
            this.alert = getAlertMessage(err);
          },
        );
    }
  }
  async convertToIDM() {
    let ref = this.modalService.create<UserActivateWithPasswordComponent>(
      UserActivateWithPasswordComponent,
      {
        size: "lg",
        backdrop: "static",
      },
    );
    let f = <UserActivateWithPasswordComponent>ref.component;
    f.firstName = this.user.firstName;
    f.lastName = this.user.lastName;
    f.userName = this.user.userName;
    let password: string = await ref.modalRef.result;

    if (password) {
      this.messageService.showSpinner();
      this.userService.convertToIDM(this.user.ssoid, password).subscribe(
        async (_) => {
          await this.getUser(this.user.ssoid);
          this.messageService.hideSpinner();
        },
        (err) => {
          this.messageService.hideSpinner();
          this.alert = getAlertMessage(err);
        },
      );
    }
  }

  open(action) {
    // this.user = user;
    this.userAction = action;
    if (action === "Enroll MFA") {
      this.modalService.openModal(EnrollMfaComponent);
      this.modalReference = this.modalService.modalRef;
      const component = <EnrollMfaComponent>(
        this.modalReference.componentInstance
      );
      component.user = this.user;
      component.smsMFAPending = this.pendingActivation;
      /* this.modalReference.result.then((result) => {
        console.log(result);
      }).catch((error) => {
        console.log(error);
      }); */
      let params = new HttpParams();
      component.clickevent.subscribe(($event) => {
        if ($event instanceof UntypedFormGroup) {
          const phoneFactorForm = $event;
          if (this.pendingActivation) {
            params = params.set(
              "code",
              phoneFactorForm.get("smsPhoneCode").value,
            );
            this.activateFactor(this.user.ssoid, params);
          } else {
            params = params.set(
              "phoneNumber",
              phoneFactorForm.get("phoneNumber").value,
            );
            this.setFactor(this.user.ssoid, params);
          }
        }
      });

      component.updateEvent.subscribe(($event) => {
        if ("update" === $event) {
          this.modalReference.componentInstance.user = this.user;
          this.modalReference.componentInstance.smsMFAAction = $event;
        }
      });

      component.authorizeEvent.subscribe(($event) => {
        if ("authorize" === $event) {
          this.modalReference.close();
          params = params.set("authorize", this.user.factor.phoneNumber);
          this.enableFactor(this.user.ssoid, params);
        }
      });

      this.modalReference.result.then((result) => {
        if (result === "disable") {
          this.disableFactor(this.user.ssoid);
        }
      });
    } else {
      this.modalService.openModal(UserDetailActionsModalComponent);
      this.modalReference = this.modalService.modalRef;
      const component = <UserDetailActionsModalComponent>(
        this.modalReference.componentInstance
      );
      component.user = this.user;
      component.userAction = this.userAction;
      component.temporaryPassword = this.temporaryPassword;
      component.userDetailActionsEvent.subscribe(($action) => {
        this.modalSubmit($action);
      });
      component.copyActionEvent.subscribe(($action) => {
        this.copyToClipboard($action);
      });
      component.temporaryPasswordActionEvent.subscribe(($action) => {
        this.submitTemporaryPassword($action);
      });

      this.modalReference.result.then(
        (result) => {
          this.temporaryPassword = null;
        },
        (reason) => {
          // console.log(`Dismissed ${reason}`);
          this.temporaryPassword = null;
        },
      );
    }
  }
  submitTemporaryPassword(action: any) {
    this.setTemporaryPassword(this.user.ssoid, action);
  }

  modalSubmit(action) {
    // TODO: change to switch case ?
    if (action === "Suspend") {
      this.suspend(this.user.ssoid);
    } else if (action === "Deactivate") {
      this.deactivate(this.user.ssoid);
    } else if (action === "Delete") {
      this.delete(this.user.ssoid);
    } else if (action === "ExpirePassword") {
      this.expirePassword(this.user.ssoid);
    } else if (action === "Reset Password") {
      this.resetPassword(this.user.ssoid);
    } else if (action === "Activate") {
      this.activate(this.user.ssoid, this.user.status);
    }
  }

  enableFactor(id: string, params: HttpParams) {
    this.userService.setFactor(id, params).subscribe(
      (res) => {
        this.getUser(id);
        this.userAction = "AuthorizeMFA"; // TODO: Have to drive all these actions from a service class
        this.showMessage = true;
        window.scroll(0, 0);
        this.clearAlerts();
      },
      (error) => {
        this.modalReference.close();
        this.alert = getAlertMessage(error);
      },
    );
  }

  setFactor(id: string, params: HttpParams): void {
    this.userService.setFactor(id, params).subscribe(
      (res) => {
        this.getUser(id);
        this.pendingActivation = true;
        if (this.modalReference.componentInstance) {
          this.modalReference.componentInstance.smsMFAPending = true;
        }
      },
      (error) => {
        this.modalReference.close();
        this.alert = getAlertMessage(error);
      },
    );
  }

  activateFactor(id: string, params: HttpParams): void {
    this.userService.activateFactor(id, params).subscribe(
      (res) => {
        this.modalReference.close();
        this.getUser(id);
        this.userAction = "ActivateMFA"; // TODO: Have to drive all these actions from a service class
        this.showMessage = true;
        window.scroll(0, 0);
        this.clearAlerts();
      },
      (error) => {
        this.alert = getAlertMessage(error);
        this.modalReference.close();
      },
    );
  }

  disableFactor(id: string): void {
    this.userService.disableFactor(id).subscribe(
      (res) => {
        this.pendingActivation = false;
        this.modalReference.close();
        this.userAction = "DeleteMFA";
        this.getUser(id);
        this.showMessage = true;
        window.scroll(0, 0);
        this.clearAlerts();
      },
      (error) => {
        this.alert = getAlertMessage(error);
        this.modalReference.close();
      },
    );
  }

  suspend(id: string): void {
    this.userService.suspend(id).subscribe(
      (res) => {
        /*  Array.prototype.push.apply(this.users, res);
           window.scrollTo(0, 0); */
        this.modalReference.close();
        this.getUser(id);
        this.showMessage = true;
        window.scroll(0, 0);
        this.clearAlerts();
      },
      (error) => {
        // console.log("error while suspending an user");
        this.alert = getAlertMessage(error);
        this.modalReference.close();
      },
    );
  }

  deactivate(id: string): void {
    this.userService.deactivate(id).subscribe(
      (res) => {
        /*  Array.prototype.push.apply(this.users, res);
           window.scrollTo(0, 0); */
        this.modalReference.close();
        this.getUser(id);
        this.showMessage = true;
        window.scroll(0, 0);
        this.clearAlerts();
      },
      (error) => {
        // console.log("error while deactivating an user");
        this.alert = getAlertMessage(error);
        this.modalReference.close();
      },
    );
  }

  activate(id: string, status: string): void {
    // Use this.user.usesMatrixcare instead of form control since checkbox is no longer bound
    const usesMatrixcareChecked = this.user.usesMatrixcare;

    //this code added to inform user they are activating a user that does not have uses matrixcare enabled and by default will get snf
    if (!usesMatrixcareChecked && this.isPhysicianNppaUser) {
      let w = this.modal.create<UsesMatrixcareConfirmationDialogComponent>(
        UsesMatrixcareConfirmationDialogComponent,
      );
      //let result = await w.modalRef.result;
      w.modalRef.result.then((result) => {
        if (result) {
          this.userAction = "Activate";
          this.userService.activate(this.user, status).then(
            (res) => {
              /*  Array.prototype.push.apply(this.users, res);
                 window.scrollTo(0, 0); */
              if (res != null) {
                if (this.modalReference) {
                  this.modalReference.close();
                }
                this.getUser(id);
                this.showMessage = true;
                window.scroll(0, 0);
                this.clearAlerts();
              }
            },
            (error) => {
              // console.log("error while activating an user");
              this.alert = getAlertMessage(error);
              if (this.modalReference) {
                this.modalReference.close();
              }
            },
          );
        }
      });
    } else {
      this.userAction = "Activate";
      this.userService.activate(this.user, status).then(
        (res) => {
          /*  Array.prototype.push.apply(this.users, res);
             window.scrollTo(0, 0); */
          if (res != null) {
            if (this.modalReference) {
              this.modalReference.close();
            }
            this.getUser(id);
            this.showMessage = true;
            window.scroll(0, 0);
            this.clearAlerts();
          }
        },
        (error) => {
          // console.log("error while activating an user");
          this.alert = getAlertMessage(error);
          if (this.modalReference) {
            this.modalReference.close();
          }
        },
      );
    }
  }

  delete(id: string): void {
    this.userService.delete(id).subscribe(
      (res) => {
        /*  Array.prototype.push.apply(this.users, res);
           window.scrollTo(0, 0); */
        this.modalReference.close();
        this.router.navigate(["/users"]).then((status) => {
          if (status) {
            this.messageService.send(MessageType.UserDeleted);
          }
        });
      },
      (error) => {
        // console.log("error while deleting an user");
        this.alert = getAlertMessage(error);
        this.modalReference.close();
      },
    );
  }

  unlock(id: string): void {
    this.userAction = "Unlock";
    this.userService.unlock(id).subscribe(
      (res) => {
        /*  Array.prototype.push.apply(this.users, res);
           window.scrollTo(0, 0); */
        this.getUser(id);
        this.showMessage = true;
        this.clearAlerts();
      },
      (error) => {
        // console.log("error while unlocking an user");
        this.alert = getAlertMessage(error);
      },
    );
  }

  private setDiscipline() {
    this.isDisciplineRequired = false;
    let role = getRoleFromName(this.roles, this.user.role);
    if (!role) {
      role = this.getCustomData(this.user.role);
    }
    if (role) {
      this.isDisciplineRequired = role.disciplineRequired;
      this.isCustomRole = role.isCustomData;
    }
  }

  public localAdminAndEditingSelf = false;
  public loadingUser = false;
  loadingUserType: string;
  selectedPolicies = "";
  async getUser(id: string, loadOptions: boolean = true) {
    if (this.updateUserForm.get("corporationName")) {
      this.updateUserForm.controls["corporationName"].setErrors(null);
    }
    if (this.updateUserForm.get("primaryDiscipline")) {
      this.updateUserForm.get("primaryDiscipline").setErrors(null);
    }
    this.loadingUser = true;
    this.loadingUserType = this.user.userType;
    // These three calls are independent of each other, run them concurrently instead of
    // sequentially to cut the round-trip time (was 3 chained awaits, now a single wait).
    const [u, isLocationAdmin, userId] = await Promise.all([
      this.userService.getUser(id).toPromise(),
      this.secSvc.isUserManagementLocalAdmin().toPromise(),
      this.secSvc.getUserId(),
    ]);

    // if(u && u.configId) {
    //   await this.checkIfMulticareEnabled(u.configId);
    // }
    if (u.userType === UserTypeNames.Corporate) {
      this.corporateLimited = true;
    } else {
      this.corporateLimited = false;
    }
    this.loadingUser = false;

    if (this.usernameDomains.length > 1) {
      this.selectedFederatedLoginIdDomain = this.usernameDomains[0];
    }
    this.originalFederatedIdentityId = u.federatedLoginID; // Store the id before changing it, so it can be dispolay in read only

    this.originalConfigId = u.configId;
    this.securityService
      .isUserLocationLimitedAdmin()
      .subscribe((x) => (this.isUserLocationLimitedAdmin = x));
    if ((isLocationAdmin && userId == id) || this.isUserLocationLimitedAdmin) {
      this.localAdminAndEditingSelf = true;
    }

    this.profileLoading = false;
    this.user = u;
    this.user.physicianNppaEnabled = u.physicianNppaEnabled;
    this.user.usesMatrixcare = u.usesMatrixcare;
    this.syncSelectedSignOnPolicies(u.factor?.signOnPolicyList || []);

    this.selectedPolicies = this.getPolicyNames() || "";

    let createUserSlProvisioned = this.route.snapshot.queryParamMap.get(
      "createSlProvisioned",
    );
    if (createUserSlProvisioned === "true") {
      this.confirmedAccessSL = true;
    } else {
      this.confirmedAccessSL = this.user.slProvisioned;
    }
    this.user.pdProvisioned = u.pdProvisioned;
    this.confirmedAccessPD = this.user.pdProvisioned;

    if (this.userService.isDummyEmail(this.user.email)) {
      this.user.email = "";
    }

    this.savedEmail = this.user.email;
    if (this.user.factor == null) {
      this.signOnOptions = [];
    } else {
      this.signOnOptions = this.allPolicies.map<IMultiSelectOption>((x) => {
        return {
          id: x.id,
          name: x.name,
          classes: x.status !== "Active" ? "disableItem" : "",
        };
      });
    }

    if (loadOptions) {
      this.snfProduct.loading = true;
      this.slProduct.loading = true;
      await this.loadOptions();
    } else {
      this.setUserEnvironmentName();
    }
    let parts = this.user.userName.split("@");
    if (this.user.userName == this.user.federatedLoginID) {
      let sameAsUsernameControl = this.updateUserForm.get("sameAsUsername");
      sameAsUsernameControl.setValue(true);
      this.sameAsUsernameChanged(sameAsUsernameControl.value); // manually run the change code
    }
    this.extractFederatedLoginDomain();

    this.userTypeChanged(false);
    this.corporationChanged(null);

    this.originalDeactivationDate = u.deactivationDate;
    this.convertDeactivationDateFormat(u);
    if (u.deactivationDate) {
      this.minDate = this.user.deactivationDate;
    }

    // Reload facility roles after user data is refreshed
    if (
      this.isFacilityRoleAssignmentFormLoaded &&
      this.user.physicianNppaEnabled
    ) {
      this.loadFacilityRoles();
    }
  }

  convertDeactivationDateFormat(user: User) {
    if (user.deactivationDate) {
      this.user.deactivationDate = new Date(user.deactivationDate);
    }
  }

  validFeratedLoginId() {
    if (!this.federationLoginIdEnabled) return true;

    if (!this.user.federatedIdentity) return true;

    if (!this.selectedFederatedLoginIdDomain) return false;

    return true;
  }
  addCustomData(options: any[], name: string): any {
    if (!options) return;

    if (!name || name.trim() == "") return;

    for (var i = 0; i < options.length; i++) {
      let option = options[i];
      if (option.text == name) {
        return;
      }
    }

    options.push({ text: name, id: name, data: this.getCustomData(name) });
  }
  public roleSettings = {
    tags: true,
    placeholder: "Not Selected",
    width: "100%",
    createTag: (params) => this.createRoleOption(params),
  };

  public getCustomData(name: string) {
    let data: any = {};
    data.disciplineRequired = true;
    data.isCustomData = true;
    data.name = name;
    return data;
  }

  createRoleOption(params: any) {
    let term = params.term.trim();
    if (!term) return;

    return {
      id: term,
      text: term,
      data: this.getCustomData(term),
    };
  }
  expirePassword(id: any): any {
    this.userService.expirePassword(id).subscribe(
      (res) => {
        this.temporaryPassword = res;
        this.modalReference.componentInstance.temporaryPassword =
          this.temporaryPassword;
      },
      (error) => {
        this.alert = getAlertMessage(error);
        this.modalReference.close();
      },
    );
  }

  resetPassword(id: any): any {
    this.userService.resetPassword(id).subscribe(
      (res) => {
        /* success messages? */
        this.modalReference.close();
        this.getUser(id);
        this.emailMessage = true;
        this.showMessage = true;
        this.clearAlerts();
      },
      (error) => {
        this.alert = getAlertMessage(error);
        this.modalReference.close();
      },
    );
  }

  setTemporaryPassword(id: any, tempPassword: string): any {
    this.userService.setTempPassword(id, tempPassword).subscribe(
      (res) => {
        /* success messages? */
        this.modalReference.close();
        this.getUser(id);
        this.emailMessage = false;
        this.showMessage = true;
        this.clearAlerts();
      },
      (error) => {
        this.alert = getAlertMessage(error);
        this.modalReference.close();
      },
    );
  }

  getStatusCssClasses(statusCode: number) {
    let cssClasses;
    if (statusCode === 1) {
      cssClasses = "fa fa-clock-o mr-2 mb-2 primary";
    } else if (statusCode === 2) {
      cssClasses = "fa fa-times mr-2 mb-2 danger";
    } else if (statusCode === 3) {
      cssClasses = "fa fa-check mr-2 mb-2 success";
    } else {
      cssClasses = "";
    }

    return cssClasses;
  }

  onChangeItem(item: TreeviewItem) {
    if (!_.isNil(item.children)) {
      item.children.forEach((child) => {
        if (item.checked) {
          child.setCheckedRecursive(item.checked);
          child.disabled = item.checked;
        } else {
          if (this.editAccess) {
            child.disabled = item.checked;
            child.setCheckedRecursive(item.checked);
          }
        }
      });
    }
    this.treeviewComponent.raiseSelectedChange();
  }

  onSelectedChange(downlineItems: DownlineTreeviewItem[]) {
    this.selectedRegions = [];
    downlineItems.forEach((downlineItem) => {
      const item = downlineItem.item;
      const value = item.value;
      let parent = downlineItem.parent;

      if (item.disabled) {
        // This will be the root of the checked items which is not disabled. This is to reflect the functionality we have in SNF.
        while (!_.isNil(parent) && parent.item.checked) {
          if (!parent.item.disabled) {
            let obj = {
              id: parent.item.value.id,
              name: parent.item.value.name,
              type: parent.item.value.type,
            };
            const index = this.selectedRegions.findIndex(
              (item) => item.id === obj.id && item.type === obj.type,
            );
            if (index === -1) {
              this.selectedRegions.push(obj);
            }
          }
          parent = parent.parent;
        }
      } else {
        let obj = {
          id: value.id,
          name: value.name,
          type: value.type,
        };
        this.selectedRegions.push(obj);
      }
    });
  }

  private setSelectedRegions() {
    // set selected regions
    let currentCorporation = this.getCurrentCorporation();
    if (currentCorporation) {
      this.regionsTree = this.userService.setSelectedRegions(
        currentCorporation.regions,
        this.user.userRegions,
      );
      this.userDetailService.sortRegionsTree(this.regionsTree);
    }
  }

  //resetValues=true called from the dropdown, otherwise called when loading options
  public async userAccessTypeChanged(resetValues = true) {
    if (this.isPhysicianNppaUser) {
      this.userTypeData = [{ text: "Corporate", id: "Corporate" }];
    } else {
      this.userTypeData = await this.userDetailService.getUserTypes();
    }
    if (resetValues) {
      if (
        !this.user.userType &&
        (this.user.adminToolRole == "LMA" || this.user.adminToolRole == "LLA")
      ) {
        this.user.userType = "Care Setting";
      }
      if (
        this.user.adminToolRole != "LMA" &&
        this.user.userType != "Corporate" &&
        this.user.adminToolRole != "LLA"
      ) {
        this.user.userType = "";
      }

      this.user.corporationName = "";

      setTimeout(() => {
        this.user.role = null;
        this.updateUserForm.get("primaryDiscipline").setValue(null);
        this.updateUserForm.get("corporationName").setValue(null);
        this.updateUserForm.get("careSettingName").setValue(null);
        this.updateUserForm.get("role").updateValueAndValidity();
        this.isDisciplineRequired = false;
      });
      this.userTypeChanged(true);
    }
  }

  getFormValidationErrors() {
    Object.keys(this.updateUserForm.controls).forEach((key) => {
      const controlErrors: ValidationErrors =
        this.updateUserForm.get(key).errors;
      if (controlErrors != null) {
        Object.keys(controlErrors).forEach((keyError) => {
          console.log(
            "Key control: " + key + ", keyError: " + keyError + ", err value: ",
            controlErrors[keyError],
          );
        });
      }
    });

    console.log("raw", this.updateUserForm.getRawValue());
    console.log("user", this.user);
  }

  public async canLmaDeactivateSuspend(id: any) {
    let userSsoId = await this.secSvc.getUserId();
    if (userSsoId == id) {
      let isLocationManagerAdmin = await this.secSvc
        .isUserManagementLocalAdmin()
        .toPromise();
      return !isLocationManagerAdmin;
    } else {
      return true;
    }
  }

  adminToolRoleDataContains(roleId: string) {
    return this.adminToolRoleDataDictionary.has(roleId);
  }

  async updateUsername() {
    let dialog = this.modalService.create<EditUsernameDialogComponent>(
      EditUsernameDialogComponent,
    );
    let result = await dialog.modalRef.result;
    if (result) {
      this.user.userName = `${dialog.component.newUsername.trim()}@${dialog.component.selectedDomain}`;
      this.updateUserProfile();
    }
  }

  getPolicyNames() {
    let policyNames = new Array<string>();
    if (this.user.factor) {
      for (let p of this.user.factor.signOnPolicyList) {
        let policyFound = this.policiesDictionary.get(p.name);
        if (policyFound) {
          policyNames.push(policyFound.name);
        }
      }
      return policyNames.join(", ");
    }
  }

  onDeactivationDateChange(value: any) {
    if (!value || value == "") {
      this.updateUserForm.get("deactivationDate").setErrors(null);
    }
  }

  public disciplineSettings = {
    tags: false,
    placeholder: "Not Selected",
    width: "100%",
  };

  async onPhysicianNppaChange(isChecked: boolean): Promise<void> {
    if (isChecked) {
      this.updateUserForm.patchValue({ usesMatrixcare: true });

      this.userAccessTypeChanged();
      this.isPhysicianNppaUser = true;
      this.user.deactivationDate = "";
      this.updateUserForm.patchValue({
        usesMatrixcare: true,
        adminToolRole: "RU",
        deactivationDate: "",
      });
      this.user.usesMatrixcare = true;
      // Set userType no admin rights if physician user
      this.user.adminToolRole = "RU";
      this.userTypeData = [{ text: "Corporate", id: "Corporate" }];
      // If user previously had usertype set (aka they were nf user) then set value to corporate else null
      this.user.userType = this.user.userType ? "Corporate" : null;
      const configId = this.user.configId; // Example: Get configId from route params
      // Build a Set of facility IDs the current user can access (from referenceData, already LMA-filtered)
      let accessibleFacilityIdsOnChange = new Set<number>();
      if (configId) {
        await this.fetchAndProcessCorporateStructure(configId);
        for (const option of this.userDetailOptions) {
          if (String(option.configId) === String(this.user.configId)) {
            option.facilities.forEach(f => accessibleFacilityIdsOnChange.add(f.id));
            break;
          }
        }

        // Use the full facility list from corporateStructureObject (already fetched, not LMA-filtered)
        const allFacilitiesOnChange: { id: number; name: string }[] =
          (this.corporateStructureObject?.facilities || []).map((f: any) => ({ id: f.id, name: f.name }));

        this.facilitiesForRoleAssignment = allFacilitiesOnChange;
      }
      this.facilityRoleAssignmentForm = this.fb.group({
        facilities: this.fb.array(
          this.facilitiesForRoleAssignment.map((facility) =>
            this.fb.group({
              checked: false,
              id: [facility.id, Validators.required],
              name: [facility.name, Validators.required],
              role: [""], // Default to an empty if roles are undefined
              accessible: [!this.isLocationAdmin || accessibleFacilityIdsOnChange.has(facility.id)],
            }),
          ),
        ),
      });
      // Set the flag to true after the form is initialized
      this.isFacilityRoleAssignmentFormLoaded = true;
      this.cdr.detectChanges();
    }
    // Update validators for title, primaryPhone, and email fields
    this.updateFormFieldValidators(this.updateUserForm, isChecked);
    // Optionally, update the form's validity
    this.updateUserForm.updateValueAndValidity();
  }

  onFacilityRoleCheckedChange(index: number): void {
    const facilitiesArray = this.facilityRoleAssignmentForm.get(
      "facilities",
    ) as FormArray;
    const facilityGroup = facilitiesArray.at(index);
    const roleControl = facilityGroup.get("role");

    if (facilityGroup.get("checked")?.value) {
      // Add required validator to the role field
      roleControl?.enable({ emitEvent: false });
      roleControl?.addValidators(Validators.required);
      roleControl?.updateValueAndValidity();
      // Update the parent form's validity
      this.facilityRoleAssignmentForm.updateValueAndValidity();
    } else {
      this.selectAllChecked = false;
      // Reset the control to its initial state without emitting value/status events
      roleControl?.reset(null, { emitEvent: false });
      roleControl?.clearValidators();
      roleControl?.disable({ emitEvent: false });
      roleControl?.updateValueAndValidity({ emitEvent: false });

      // Trigger Angular's change detection explicitly
      this.cdr.detectChanges();

      // Update the parent form's validity
      this.facilityRoleAssignmentForm.updateValueAndValidity({ emitEvent: false });

      // Remove the facility from the newFacilityRoleAssignments array if unchecked
      const facilityId = facilityGroup.get("id")?.value;
      this.newFacilityRoleAssignments = this.newFacilityRoleAssignments.filter(
        (assignment) => assignment.id !== facilityId,
      );
    }
  }

  onFacilityRoleAssignmentChange(index: number): void {
    const facilitiesArray = this.facilityRoleAssignmentForm.get(
      "facilities",
    ) as FormArray;
    const facilityGroup = facilitiesArray.at(index);
    const facilityId = facilityGroup.get("id")?.value;
    const newRole = facilityGroup.get("role")?.value;

    if (facilityId && newRole) {
      // Check if the facility ID already exists in the array
      const existingAssignment = this.newFacilityRoleAssignments.find(
        (assignment) => assignment.id === facilityId,
      );

      if (existingAssignment) {
        // Update the role if it is different
        if (existingAssignment.role !== newRole) {
          existingAssignment.role = newRole;
        }
      } else {
        // Add a new assignment if it doesn't exist
        this.newFacilityRoleAssignments.push({
          id: facilityId, // Assuming `id` exists in the form group
          role: newRole,
        });
      }
    }
  }

  get areAllAccessibleChecked(): boolean {
    const facilitiesArray = this.facilityRoleAssignmentForm?.get('facilities') as FormArray;
    if (!facilitiesArray) return false;
    const accessible = facilitiesArray.controls.filter(c => c.get('accessible')?.value);
    return accessible.length > 0 && accessible.every(c => c.get('checked')?.value);
  }

  onFacilityListScroll(event: Event): void {
    this.facilityListScrolled = (event.target as HTMLElement).scrollTop > 0;
  }

  onSelectAllChange(checked: boolean): void {
    this.selectAllChecked = checked;
    this.allFacilitiesPreSelected = false;
    const facilitiesArray = this.facilityRoleAssignmentForm.get('facilities') as FormArray;

    if (checked) {
      facilitiesArray.controls.forEach((control: AbstractControl) => {
        if (!control.get('accessible')?.value) return;
        const originalRole = control.get('originalRole')?.value;
        if (originalRole === 'Physician') return;
        control.get('checked')?.setValue(true, { emitEvent: false });
        const roleControl = control.get('role');
        roleControl?.enable({ emitEvent: false });
        roleControl?.addValidators(Validators.required);
        roleControl?.updateValueAndValidity();
        if (this.defaultRole) {
          roleControl?.setValue(this.defaultRole, { emitEvent: false });
          const facilityId = control.get('id')?.value;
          const existing = this.newFacilityRoleAssignments.find(a => a.id === facilityId);
          if (existing) {
            existing.role = this.defaultRole;
          } else {
            this.newFacilityRoleAssignments.push({ id: facilityId, role: this.defaultRole });
          }
        }
      });
    } else {
      this.resetFacilityRoleAssignmentForm();
    }
    this.cdr.detectChanges();
    // Force select2 components to re-render their displayed value
    setTimeout(() => {
      facilitiesArray.controls.forEach((control: AbstractControl) => {
        const roleControl = control.get('role');
        roleControl?.setValue(roleControl.value);
      });
    }, 0);
  }

  onDefaultRoleChange(role: string): void {
    this.defaultRole = role;
    if (!this.selectAllChecked) return;
    const facilitiesArray = this.facilityRoleAssignmentForm.get('facilities') as FormArray;
    facilitiesArray.controls.forEach((control: AbstractControl) => {
      if (!control.get('accessible')?.value) return;
      const originalRole = control.get('originalRole')?.value;
      if (originalRole === 'Physician') return;
      if (!control.get('checked')?.value) return;
      control.get('role')?.setValue(role, { emitEvent: false });
      const facilityId = control.get('id')?.value;
      const existing = this.newFacilityRoleAssignments.find(a => a.id === facilityId);
      if (existing) {
        existing.role = role;
      } else {
        this.newFacilityRoleAssignments.push({ id: facilityId, role });
      }
    });
    this.cdr.detectChanges();
    // Force select2 components to re-render their displayed value
    setTimeout(() => {
      facilitiesArray.controls.forEach((control: AbstractControl) => {
        const roleControl = control.get('role');
        if (roleControl?.value) roleControl.setValue(roleControl.value);
      });
    }, 0);
  }

  loadFacilityRoles(): void {
    const facilitiesArray = this.facilityRoleAssignmentForm.get(
      "facilities",
    ) as FormArray;

    let hasPhysicianRole = false;

    facilitiesArray.controls.forEach((facilityGroup: AbstractControl) => {
      const facilityId = facilityGroup.get("id")?.value;

      // Find the matching facilityRoleAssignment by id
      const matchingAssignment = this.user.facilityRoleAssignments?.find(
        (assignment) => assignment.id === facilityId,
      );

      if (matchingAssignment) {
        // Set the role value if a match is found
        facilityGroup.get("role")?.setValue(matchingAssignment.role);
        // Store the original role from API
        facilityGroup.get("originalRole")?.setValue(matchingAssignment.role);
        // Check the checkbox if the role is present
        facilityGroup.get("checked")?.setValue(true);

        if (matchingAssignment.role === "Physician") {
          hasPhysicianRole = true;
          facilityGroup.get("checked")?.disable();
          facilityGroup.get("role")?.disable();
        } else if (this.isLocationAdmin) {
          // LMA cannot uncheck a pre-selected facility — lock checkbox only
          facilityGroup.get("checked")?.disable();
        }
      } else {
        // No matching assignment - ensure originalRole is empty
        facilityGroup.get("originalRole")?.setValue("");
      }
    });

    this.defaultRoleOptions = hasPhysicianRole
      ? ["", "Physician"]
      : [...this.facilityRoles];

    // Keep checked facilities grouped at the top, both on initial load and after a save/reload.
    this.sortFacilitiesCheckedFirst(facilitiesArray);

    this.deriveSelectAllState();
  }

  // Reorders the facilities FormArray in place (checked first) without recreating controls,
  // so disabled/validator state set above is preserved. Sort is stable, so relative API order
  // is preserved within each of the checked/unchecked groups.
  private sortFacilitiesCheckedFirst(facilitiesArray: FormArray): void {
    const sortedControls = [...facilitiesArray.controls].sort(
      (a, b) =>
        Number(!!b.get("checked")?.value) - Number(!!a.get("checked")?.value),
    );
    sortedControls.forEach((control, index) => {
      facilitiesArray.setControl(index, control, { emitEvent: false });
    });
  }

  // selectAllChecked = all accessible facilities checked; defaultRole = common role or ''.
  private deriveSelectAllState(): void {
    const facilitiesArray = this.facilityRoleAssignmentForm.get(
      "facilities",
    ) as FormArray;
    const accessibleControls = facilitiesArray.controls.filter(
      c => c.get('accessible')?.value,
    );

    this.selectAllChecked =
      accessibleControls.length > 0 &&
      accessibleControls.every(c => c.get('checked')?.value);

    // true only when called from editAccessClicked — locks Select All if pre-selected from backend
    this.allFacilitiesPreSelected = this.selectAllChecked;

    this.defaultRole = '';
  }
  /*  onUsesMatrixcareChange(isChecked: boolean): void {
      const userTypeControl = this.updateUserForm.get('userType');
      if (isChecked) {
        userTypeControl?.setValue('Provider');
      } else {
        userTypeControl?.setValue(null); // Reset the value
      }
    }*/

  getCheckedCount(): number {
    const facilitiesArray = this.facilityRoleAssignmentForm.get(
      "facilities",
    ) as FormArray;
    return facilitiesArray.controls.filter(
      (facility) => facility.get("checked")?.value,
    ).length;
  }

  private updateFormFieldValidators(
    form: UntypedFormGroup,
    physicianNppaEnabled: boolean,
  ): void {
    const fieldsToUpdate = ["title", "primaryPhone", "email"];

    fieldsToUpdate.forEach((fieldName) => {
      const control = form.get(fieldName);
      if (control) {
        if (physicianNppaEnabled) {
          // Add required validators
          control.setValidators([Validators.required]);
        } else {
          // Clear validators
          control.clearValidators();
        }
        // Update the control's validation status
        control.updateValueAndValidity();
      }
    });
  }
}
